import apiInstance from "../api";
import fileApiInstance from "../fileApi";
import endPoints from "../endpoints";

export const getOutputFiles = (payload) => {
  return apiInstance().post(`${endPoints.outputFiles.getOutputFiles}`, payload);
};

export const getDownloadSubmittedFile = (fileName) => {
  return fileApiInstance().get(
    `${endPoints.outputFiles.getDownloadSubmittedFile}/${fileName}`
  );
};
